import { useTranslation } from 'react-i18next';
import BasicPageTemplate from '@/shared/templates/basic-page';
import { Text } from '@metaicg/sensei-ui';

const AccessDenied = () => {
  const { t } = useTranslation();

  return (
    <BasicPageTemplate title={t('access-denied:page.title')}>
      <Text as="p" color="neutral.palette300">
        {t('access-denied:content.description')}
      </Text>
    </BasicPageTemplate>
  );
};

export default AccessDenied;
